import classnames from 'classnames';
import { Dispatch, SetStateAction } from 'react';

import { Input } from '../Input';
import Label from '../Label';
import Text from '../Text';

interface Props {
  className?: string;
  dateLabel: string;
  timeLabel: string;
  dateValue: string;
  timeValue: string;
  setTimeValue: Dispatch<SetStateAction<string>>;
}

const DateTimeInput = ({ className, dateLabel, timeLabel, dateValue, timeValue, setTimeValue }: Props) => {
  return (
    <div className="flex w-[252px] flex-row gap-2">
      <div className={classnames('flex w-full flex-1 flex-col', className)}>
        <Label label={dateLabel} />
        <div className="h-8 rounded border border-border-primary bg-transparent px-3 py-[5.5px]">
          <Text size="body2" weight="regular" color="primary">
            {dateValue}
          </Text>
        </div>
      </div>
      <Input
        className="flex-1 text-body2 font-regular text-text-secondary"
        label={timeLabel}
        value={timeValue}
        setValue={setTimeValue}
      />
    </div>
  );
};

export default DateTimeInput;
